var VideoPlay = (function() {
	var __private = {
		dataAttr: "data-video",

		set(ID) {
			this.playBtn = document.getElementById(ID);
			var video;

			if(this.playBtn && this.playBtn.getAttribute(this.dataAttr)) {
				video = document.getElementById(this.playBtn.getAttribute(this.dataAttr));

				this.play(video);
			}
		},

		play(video) {
			this.playBtn.addEventListener("click", function() {
				video.play();
				__private.addControls(video);
				this.style.display = "none";
			});
		},

		addControls(video) {
			if(!video.getAttribute("controls")) video.setAttribute("controls", "controls");
		}
	};

	return {
		play(buttonID) {
			__private.set(buttonID);
		}
	};
})();



// Run script
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var videoButtonID = "videoPlay";

		if(document.getElementById(videoButtonID)) VideoPlay.play(videoButtonID);
	});
})();